module.exports = __webpack_public_path__ + "img/title-bg.be1b54b3.png";